import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unsortedKeys',
  standalone: false
})
export class UnsortedKeysPipe implements PipeTransform {
  transform(keys: { [id: string]: unknown }): string[] {
    const arr = [];
    for (const key of Object.keys(keys)) {
      arr.push(key);
    }
    return arr;
  }
}
